import {
  ADD_DECISION,
  ADD_DECISION_START,
  ADD_DECISION_ERROR,
  UPDATE_DECISION,
  UPDATE_DECISION_START,
  UPDATE_DECISION_ERROR,
  GET_DECISION,
  GET_DECISION_START,
  GET_DECISION_ERROR,
  GET_DECISION_LIST,
  GET_DECISION_LIST_START,
  GET_DECISION_LIST_ERROR,
  DELETE_DECISION,
  DELETE_DECISION_START,
  DELETE_DECISION_ERROR,
  CLEAR_ERROR_DECISION,
  GET_DECISION_LIST_PAGEABLE,
  CHANGE_DECISION_STATUS,
  CHANGE_DECISION_STATUS_START,
  CHANGE_DECISION_STATUS_ERROR,
  GET_DECISION_BY_REQUEST,
  GET_DECISION_BY_REQUEST_ERROR,
  GET_DECISION_BY_REQUEST_START,
  CHANGE_STATUS_DECISION,
  CHANGE_STATUS_DECISION_START,
  CHANGE_STATUS_DECISION_ERROR,
  GET_DECISION_FILTER_LIST,
  GET_DECISION_FILTER_LIST_START,
  GET_DECISION_FILTER_LIST_ERROR,
  SEND_DECISION,
  SEND_DECISION_START,
  SEND_DECISION_ERROR,
} from '../actions/types';

const initialState = {
  decisionList: [],
  decision: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addDecisionStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const updateDecisionStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const findAllDecisionsStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findDecisionByIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findDecisionByRequestIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const deleteDecisionStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addDecisionError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateDecisionError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllDecisionsError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findDecisionByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findDecisionByRequestIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteDecisionError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addDecision = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionList: [action.payload].concat(state.decisionList),
    decision: action.payload,
    error: undefined,
  };
};

const updateDecision = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionList: state.decisionList.map((decision) =>
      decision.id === action.payload.id ? action.payload : decision
    ),
    error: undefined,
  };
};

const findAllDecisionsPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    error: undefined,
  };
};

const findAllDecisions = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionList: action.payload,
    error: undefined,
  };
};

const findDecisionById = (state, action) => {
  return {
    ...state,
    loading: false,
    decision: action.payload,
    error: undefined,
  };
};

const findDecisionByRequestId = (state, action) => {
  return {
    ...state,
    loading: false,
    decision: action.payload,
    error: undefined,
  };
};

const deleteDecision = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionList: state.decisionList.filter(
      (decision) => decision.id !== action.payload
    ),
    error: undefined,
  };
};

const changeDecisionStatusWithStatusStart = (state) => {
  return {
    ...state,
    loading: false,
    error: undefined,
  };
};

const changeDecisionStatusWithStatus = (state, action) => {
  return {
    ...state,
    loading: false,
    decision: action.payload,
    error: undefined,
  };
};

const changeDecisionStatusWithStatusError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_DECISION:
      return addDecision(state, action);
    case ADD_DECISION_START:
      return addDecisionStart(state);
    case ADD_DECISION_ERROR:
      return addDecisionError(state, action);

    case UPDATE_DECISION:
      return updateDecision(state, action);
    case UPDATE_DECISION_START:
      return updateDecisionStart(state);
    case UPDATE_DECISION_ERROR:
      return updateDecisionError(state, action);

    case GET_DECISION:
      return findDecisionById(state, action);
    case GET_DECISION_START:
      return findDecisionByIdStart(state);
    case GET_DECISION_ERROR:
      return findDecisionByIdError(state, action);

    case GET_DECISION_BY_REQUEST:
      return findDecisionByRequestId(state, action);
    case GET_DECISION_BY_REQUEST_START:
      return findDecisionByRequestIdStart(state);
    case GET_DECISION_BY_REQUEST_ERROR:
      return findDecisionByRequestIdError(state, action);

    case GET_DECISION_LIST:
      return findAllDecisions(state, action);
    case GET_DECISION_LIST_START:
    case GET_DECISION_FILTER_LIST_START:
      return findAllDecisionsStart(state);
    case GET_DECISION_LIST_ERROR:
    case GET_DECISION_FILTER_LIST_ERROR:
      return findAllDecisionsError(state, action);
    case GET_DECISION_LIST_PAGEABLE:
    case GET_DECISION_FILTER_LIST:
      return findAllDecisionsPageable(state, action);

    case DELETE_DECISION:
      return deleteDecision(state, action);
    case DELETE_DECISION_START:
      return deleteDecisionStart(state);
    case DELETE_DECISION_ERROR:
      return deleteDecisionError(state, action);
    case CLEAR_ERROR_DECISION:
      return clearError(state);

    case CHANGE_DECISION_STATUS:
      return updateDecision(state, action);
    case CHANGE_DECISION_STATUS_START:
      return updateDecisionStart(state);
    case CHANGE_DECISION_STATUS_ERROR:
      return updateDecisionError(state, action);

    case CHANGE_STATUS_DECISION:
    case SEND_DECISION:
      return changeDecisionStatusWithStatus(state, action);
    case CHANGE_STATUS_DECISION_START:
    case SEND_DECISION_START:
      return changeDecisionStatusWithStatusStart(state);
    case CHANGE_STATUS_DECISION_ERROR:
    case SEND_DECISION_ERROR:
      return changeDecisionStatusWithStatusError(state, action);
    default:
      return state;
  }
}
